declare var __DEVELOPMENT__: boolean;
declare var __BACKEND_SAME_ORIGIN__: boolean;
declare var __FRONTEND_VERSION__: string;
declare var __FRONTEND_COMMITHASH__: string;

export const DEVELOPMENT: boolean = __DEVELOPMENT__;
export const BACKEND_SAME_ORIGIN: boolean = __BACKEND_SAME_ORIGIN__;
export const FRONTEND_VERSION: string = __FRONTEND_VERSION__;
export const FRONTEND_COMMITHASH: string = __FRONTEND_COMMITHASH__;
